import { render, staticRenderFns } from "./roleDeleteConformationDialog.vue?vue&type=template&id=fbe379e0&scoped=true&"
import script from "./roleDeleteConformationDialog.vue?vue&type=script&lang=js&"
export * from "./roleDeleteConformationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe379e0",
  null
  
)

export default component.exports